import { FC } from "react"
import {
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
  Box,
} from "@mui/material"

interface CustomSingleSelectFilterProps {
  label: string
  value: string
  onChange: (event: SelectChangeEvent<string>) => void
  options: string[]
  disabledOption?: string
}

const CustomSingleSelectFilter: FC<CustomSingleSelectFilterProps> = ({
  label,
  value,
  onChange,
  options,
  disabledOption,
}) => {
  return (
    <Box gap={0.5} sx={{ display: "flex", flexDirection: "column" }}>
      {/* <Typography sx={{ fontSize: '10px', fontWeight: 400, color: (theme) => theme.palette.secondary.light }}>{label}</Typography> */}
      <FormControl size="small" fullWidth>
        <Select
          labelId="custom-single-select-label"
          value={value}
          label={""}
          onChange={onChange}
          displayEmpty
          sx={{
            ".MuiOutlinedInput-notchedOutline": {
              // borderColor: 'blue',
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "primary.main",
            },
          }}
        >
          {/* Placeholder option */}
          <MenuItem value="" disabled>
            {label}
          </MenuItem>
          {options.map((option, index) => (
            <MenuItem
              key={index}
              value={option}
              disabled={option === disabledOption}
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default CustomSingleSelectFilter
